import { render, staticRenderFns } from "./Kiosk.vue?vue&type=template&id=50c08f8c"
import script from "./Kiosk.vue?vue&type=script&lang=js"
export * from "./Kiosk.vue?vue&type=script&lang=js"
import style0 from "./Kiosk.vue?vue&type=style&index=0&id=50c08f8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports